import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logger from './utils/logger';

logger.info('Index', 'Application starting', { 
  userAgent: navigator.userAgent,
  timestamp: new Date().toISOString(),
  loggingEnabled: process.env.REACT_APP_ENABLE_LOGGING === 'true'
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  logger.error('Index', 'Root element not found', new Error('Root element #root not found in DOM'));
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
logger.debug('Index', 'React root created', { rootElementId: rootElement.id });

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

logger.info('Index', 'Application rendered', { strictMode: true });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
